module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/search-e296894fe2c18bdde8a90c8acf31be60.svg";